import type { ReactNode } from 'react'
import { cn } from '@/utils/cn'

type Props = {
  title?: string
  subtitle?: string
  actions?: ReactNode
  children: ReactNode
  className?: string
  /** Remove body padding — use for tables */
  flush?: boolean
}

export function DashboardPanel({ title, subtitle, actions, children, className, flush = false }: Props) {
  const hasHeader = Boolean(title || subtitle || actions)

  return (
    <div className={cn('dashboard-panel', className)}>
      {hasHeader ? (
        <div className="dashboard-panel__header flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
          <div className="min-w-0 space-y-1">
            {title ? <h3 className="text-base font-semibold text-foreground">{title}</h3> : null}
            {subtitle ? <p className="text-sm text-muted-foreground">{subtitle}</p> : null}
          </div>
          {actions ? <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div> : null}
        </div>
      ) : null}
      <div className={cn(flush ? 'dashboard-panel__body--flush' : 'dashboard-panel__body')}>{children}</div>
    </div>
  )
}
